
<template>
  <div class="forwardUpload">
    <div class="upload" v-if="saveBtn">
      <div class="sel">
        <label>附件上传项 :&nbsp;</label>
        <Select v-model="selectData" transfer clearable>
          <Option v-for="(item , index) in uploadItem" :key="index" :value="item.limitval">{{item.limitdesc}}</Option>
        </Select>
      </div>
      <div class="upl" v-if="uplShow">
        <label>附件上传 :&nbsp;</label>
        <Upload action="/p/cs/batchUpload" name="files" :before-upload="beforeUpload"  :accept="acceptFile" :on-success="onSuccess" :on-error="onError" :on-remove="onRemove" :data="uplData">
          <span class="uplFile">
            <Icon type="md-cloud-upload" />上传附件
          </span>
        </Upload>
      </div>
    </div>
    <div class="pageNation">
      <Page :total="page.total" show-sizer :page-size-opts="page.pageSizeOpts" :current="page.current" :page-size="page.pageSize" @on-change="pageChange" @on-page-size-change="pageSizeChange" />
      <div class="button">
        <span v-if="saveBtn" @click="save({detail:{type:'saveWithWorwardUpload'}})">【保存】</span>
        <span v-if="deleteBtn" @click="delItem">【删除明细】</span>
        <!-- <span>【导入】</span>
        <span @click="exportFile">【导出】</span>-->
      </div>
    </div>
    <div class="table">
      <Table :columns="tableConfig.columns" :data="tableConfig.data" @on-selection-change="onSelectChange"></Table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import uploadDalog from './uploadDalog';
Vue.component('uploadDalog', uploadDalog);
const mapping = {
  "CL_C_CHANGE_FLOW": { //客户认证申请
    tableName: "CL_C_CHANGE_FLOW_ANNEX_ITEM",
    tableId: 249130685,
    refcolId: 1700844101,
  },
}
export default {
  name: 'forwardUpload',
  data() {
    return {
      saveBtn: true,
      deleteBtn: true,
      uplShow: true,
      page: {
        total: 1,
        start: 0,
        current: 1,
        pageSize: 10,
        pageSizeOpts: [1, 10, 20, 30, 50]
      },
      acceptFile: '.dwg,.xls,.pptx,.jpg,.pdf,.xlsx,.ppt,.msg,.doc,.png,.docx,.txt,.rar,.dxf,.dwl,.zip,.mp4,.eml,.bmp,.jpeg,.et,.rtf,.jfif,.xlsb,.pub,.exb,.webp,.tif,.csv',
      // formatFile:['dwg','xls','pptx','jpg','pdf','xlsx','ppt','msg','doc','png','docx','txt','rar','dxf','dwl','zip','mp4','eml','bmp','jpeg','et','rtf','jfif','xlsb','pub','exb','webp','tif','csv'],
      uploadItem: [],
      files: [],
      selectData: '',
      uplData: {
        path: ''
      },
      tableConfig: {
        columns: [],
        data: [

        ]
      },
      onSelectChangeData: [],
      CL_C_CHANGE_FLOW_FORMDATA:''
    }
  },
  created() {
    this.initData();
    this.getTableData();
    window.addEventListener('customizeClick', this.save);
  },
  activated() {
    this.refresh();
  },
  destroyed() {
    window.removeEventListener('customizeClick', this.save);
  },
  watch:{
    "CL_C_CHANGE_FLOW_FORMDATA": {
        handler (newName, oldName) {
            console.log(newName)
        },
        // immediate: true
        deep: true
    }
  },
  
  mounted(){
    // 监听列表值-赋值
    // let tiemer = setInterval(()=>{
    //   if(R3.store.state['V.CL_C_CHANGE_FLOW.249130685.New'].updateData.CL_C_CHANGE_FLOW){
    //     this.CL_C_CHANGE_FLOW_FORMDATA = R3.store.state['V.CL_C_CHANGE_FLOW.249130685.New'].updateData.CL_C_CHANGE_FLOW
    //     clearInterval(tiemer)
    //   }

    // },500)
    
  },
  methods: {
    refresh() {  //刷新
      this.initData();
      this.getTableData();
      this.selectData = undefined;
      this.uplShow = false;
      this.page.current = 1
      this.$nextTick(() => {
        this.uplShow = true;
        this.files = [];
        this.onSelectChangeData = []
      })
    },
    initData() {
      // console.log('userInfo :>> ', this.$store.state.global.userInfo);
      const { tableName, tableId, itemId } = this.$router.currentRoute.params;
      axios({
        url: '/p/cs/jflowChangeBtnIsHide',
        method: 'post',
        data: {
          table: tableName,
          tableId: tableId,
          objid: itemId == 'New' ? -1 : itemId,
          userid: this.$store.state.global.userInfo.id
        }
      }).then(res => {
        if (res.data.data.code == 0) {
          let { deleteHide, saveHide } = res.data.data.data
          this.saveBtn = !saveHide;
          this.deleteBtn = !deleteHide;
        } else {
          this.$Message.error(res.data.data.message);
        }
      });

      this.uplData.path = `${mapping[tableName].tableName}/${itemId}/${new Date().getTime()}/`

      let formdata = new FormData();
      formdata.append('table', mapping[tableName].tableName);
      formdata.append('inlinemode', 'Y')
      //   this.uplData.path = `${this.$route.params.tableName}/${this.$route.params.itemId}/${new Date().getTime()}/`
      //   formdata.append('table', 'CL_C_VI_DESIGN_COMMIT');
      //   formdata.append('inlinemode', 'Y')
      axios({
        url: '/p/cs/inputForitem',
        method: 'post',
        data: formdata
      }).then(res => {
        if (res.data.code == 0) {
          this.uploadItem = res.data.data.inpubobj.filter(item => item.colname == "UPLOAD_ITEM")[0].combobox;
        }
      });
    },
    getTableData() {
      this.tableConfig.columns = [];
      let obj = {};
      obj['startindex'] = this.page.pageSize * (this.page.current - 1);
      obj['range'] = this.page.pageSize;
      obj['column_include_uicontroller'] = true;
      let formdata = new FormData();
      //   formdata.append('table', 'CL_C_VI_DESIGN_COMMIT');
      //   formdata.append('objid', this.$route.params.itemId);
      //   formdata.append('refcolid', 1700841239);
      //   formdata.append('searchdata', JSON.stringify(obj));
      const { tableName, itemId } = this.$router.currentRoute.params;
      formdata.append('table', mapping[tableName].tableName);
      formdata.append('objid', itemId == 'New' ? -1 : itemId);
      formdata.append('refcolid', mapping[tableName].refcolId);
      formdata.append('searchdata', JSON.stringify(obj));
      axios({
        url: '/p/cs/objectTableItem',
        method: 'post',
        data: formdata
      }).then(res => {
        if (res.data.code == 0) {
          // console.log('getTableData.datas :>> ', res.data.datas);
          let arr = [];
          res.data.datas.tabth.forEach(item => {
            if (item.colname !== 'ID') {
              let obj = {};
              obj['title'] = item.name;
              obj['key'] = item.colname
              arr.push(obj);
            } else {
              let obj = {};
              obj['type'] = 'selection';
              obj['name'] = item.name;
              obj['colname'] = item.colname
              arr.push(obj);
            }
          });
          this.page.total = res.data.datas.totalRowCount; //总条数
          this.page.start = res.data.datas.start; //开始条数
          this.page.pageSize = res.data.datas.defaultrange; //每页条数
          this.page.pageSizeOpts = res.data.datas.selectrange;
          this.tableConfig.columns = arr
          this.renderColumn(this.tableConfig.columns);
          let tempTableData = res.data.datas.row.map(item => {
            let obj = {};
            for (let key in item) {
              obj[key] = item[key].val;
            }
            return obj;
          });
          // console.log('tempTableData :>> ', JSON.parse(JSON.stringify(tempTableData)));
          this.tableConfig.data = tempTableData
        }
      })
    },
    beforeUpload(file){
      // console.log('file :>> ', file);
      if(file.name.includes(',')){
        this.$Modal.fcError({
          title: '错误',
          content: '文件名不支持英文逗号,',
          showCancel: false,
        })
        return false
      }else{
        return true
      }
    },
    onSuccess(res, file, filelist) {
      if (res.code == 0) {
        this.files = filelist;
        // console.log('filelist :>> ', filelist);
        // let data = '';
        // let formdata = new FormData();
        // data = this.files.map(res => {
        //   return res.response.data[0].UploadId;
        // });
        // formdata.append('uploadIds', data.join(','));
        // axios({
        //   url: '/p/cs/batchUploadProgress',
        //   method: 'post',
        //   data: formdata
        // }).then(res => {
        // })
      } else {
        // console.log('filelist :>> ', filelist);
        // console.log('file :>> ', file);
        let newFiles = filelist.filter(item => item.uid != file.uid)
        console.log('newFiles :>> ', newFiles);
        // this.$Message.warning(res.message);
        this.$Modal.fcError({
          title: '错误',
          content: res.message,
          showCancel: false,
        })
      }
    },
    onError(e) {
      // this.$Message.warning(e.message);
      this.$Modal.fcWarning({
        title: '提示',
        content: e.message,
        showCancel: false,
      })
    },
    onRemove(res, filelist) {
      this.files = filelist;
    },
    save(e) {
      if (e.detail.type == 'refresh') {
        this.initData();
        this.getTableData();
        // this.refresh();
        // return
      }
      // console.log('this.files :>> ', this.files);
      if (e.detail.type == 'save') { //点击上面的保存时
        if (this.selectData && this.files.length > 0) {
          this.saveData()
        }
      }
      if (e.detail.type == 'saveWithWorwardUpload') { //点击附件的保存
        if (!this.selectData || this.files.length == 0) {
          this.$Message.warning('附件上传项与附件上传不能为空!');
        } else {
          this.saveData()
        }
      }
    },
    saveData() {
      let data = {};
      let arr = this.files.map(item => {
        let obj = {};
        obj['name'] = item.response.data[0].Name;
        obj['url'] = item.response.data[0].Url;
        obj['Size'] = item.response.data[0].Size;
        return obj;
      });
      const { tableName, itemId } = this.$router.currentRoute.params;
      let mapTableName = mapping[tableName].tableName
      data[mapTableName] = [{}];
      data[mapTableName][0]['UPLOAD_ITEM'] = this.selectData;
      data[mapTableName][0]['TYPE'] = JSON.stringify(arr);
      data[mapTableName][0]['ID'] = -1;
      let formdata = new FormData();
      formdata.append('table', tableName);
      formdata.append('objid', itemId);
      formdata.append('data', JSON.stringify(data));
      R3.network.post('/p/cs/objectSave', formdata).then(res => {
        if (res.data.code == 0) {
          this.$Message.success(res.data.message);
          this.refresh();
        } else {
          this.$Message.error(res.data.message);
        }
      })

      
    },
    renderColumn(column) {
      column.forEach(item => {
        if (item.key == 'TYPE') {
          item['render'] = (h, params) => {
            if (!params.row.TYPE) return
            let str = JSON.parse(params.row.TYPE).map(item => {
              return `【${item.name}】`
            })
            return h('div', {
              style: {
                position: 'relative'
              }
            },
              [
                h('span', {
                }, str),
                h('Poptip', {
                  props: {
                    trigger: 'click',
                    transfer: true,
                    content: 'content'
                  },
                  scopedSlots: {
                    default: () => h('div', {
                      style: {
                        'padding-left': '10px',
                        'padding-right': '10px',
                      },
                      domProps: {
                        innerHTML: '<i class="iconfont iconbj_listedit" style="color: #2D8CF0; font-size: 16px"></i>'
                      },
                    }),
                    content: () => h('uploadDalog', {
                      props: {
                        uploadData: params.row
                      },
                      on: {
                        'refresh': () => {
                          this.refresh();
                        }
                      }
                    })
                  }
                })
              ])
          }
        }
        // console.log('column :>> ', column);
      })
    },
    onSelectChange(sel) {
      this.onSelectChangeData = sel;
    },
    delItem() {
      if (this.onSelectChangeData.length == 0) {
        this.$Message.warning('请选择删除项!');
        return;
      }
      this.$Modal.fcWarning({
        title: '提示',
        content: '确认执行删除?',
        showCancel: true,
        onOk: () => {
          // let obj = {};
          // obj['table'] = this.$route.params.tableName;
          // obj['objid'] = this.$route.params.itemId;
          // obj['isdelmtable'] = 'isdelmtable';
          // let data = {}
          // data['CL_C_VI_DESIGN_COMMIT'] = this.onSelectChangeData.map(item => item.ID);
          // obj['data'] = data;
          // R3.network.post('/p/cs/storeViAnnexDelete', R3.urlSearchParams(obj)).then(res => {

          const { tableName, itemId } = this.$router.currentRoute.params;
          const mapTableName = mapping[tableName].tableName
          const data = {}
          data[mapTableName] = this.onSelectChangeData.map(item => item.ID)

          const formdata = new FormData();
          formdata.append('table', tableName);
          formdata.append('objid', itemId);
          formdata.append('isdelmtable', false);
          formdata.append('data', JSON.stringify(data));
          R3.network.post('/p/cs/objectDelete', formdata).then(res => {
            if (res.data.code == 0) {
              this.$Message.success(res.data.message);
              this.refresh();
            } else {
              this.$Message.warning(res.data.message);
            }
          })
        }
      })
    },
    exportFile() {
      let data = {};
      let obj = {};
      obj['table'] = this.$route.params.tableName;
      obj['column_include_uicontroller'] = true;
      let fixedcolumns = {};
      fixedcolumns['ID'] = this.onSelectChangeData.length == 0 ? null : this.onSelectChangeData.map(item => item.ID);
      fixedcolumns['objectIds'] = `1700841239=${this.$route.params.itemId}`
      fixedcolumns['startindex'] = this.page.pageSize * (this.page.current - 1);
      fixedcolumns['range'] = this.page.pageSize;
      obj['fixedcolumns'] = fixedcolumns;
      data['searchdata'] = obj;
      data['filename'] = '装修设计-附件上传';
      data['filetype'] = '.xlsx';
      data['showColumnName'] = true;
      data['menu'] = '装修设计-附件上传';
      R3.network.post('/p/cs/export', R3.urlSearchParams(data)).then(res => {
        console.log(res);
      })
    },
    pageChange(val) {
      this.page.current = val;
      this.getTableData();
    },
    pageSizeChange(val) {
      this.page.pageSize = val;
      this.getTableData();
    }
  }
}
</script>

<style lang="less">
.forwardUpload {
  height: 500px;
  .upload {
    display: flex;
    background: #f8f8f8;
    .sel,
    .upl {
      white-space: nowrap;
      line-height: 26px;
      display: flex;
      width: 200px;
      margin-left: 50px;
      margin-top: 5px;
      margin-bottom: 5px;
      label:before {
        content: "*";
        color: red;
        margin-right: 2px;
      }
    }
    .upl {
      margin-left: 100px;
      .uplFile {
        cursor: pointer;
        color: #0f8ee9;
      }
    }
    .sel {
      .icon {
        color: red;
        font-size: 12px;
      }
    }
  }
  .pageNation {
    margin: 8px 0;
    display: flex;
    .button {
      color: #0f8ee9;
      margin-top: 9px;
      cursor: pointer;
    }
  }
}
</style>